module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Rainbow-319d967a5582d25ded4fb6329199b00c.svg";